import { Button, Badge, Modal, TextStyle } from '@superops/ui-design-system';
import React, { useContext, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import { useMutation } from '@apollo/client';
import { UPDATE_POLICY_SET } from '@nile/banyan/src/Graphql/Query/patch';
import { RMMClient } from '@nile/graphql';
import { toast, useActivityTracker, withErrorBoundary } from '@nile/components';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import PolicyContext from '@nile/banyan/src/Context/PolicyContext';
import { DELETE_POLICY_SET_ASSET_ONBOARDING } from '@nile/graphql';

function OverRiddenPolicyTag(props) {
  const {
    policy = {},
    policySet = {},
    policyType = '',
    fromListView = false,
    isReadOnly = false,
    isNewDelete = false
  } = props;
  const [showRevertConfirmation, setShowRevertConfirmation] = useState(false);
  const tabContext = useContext(TicketContext);
  const policyContext = useContext(PolicyContext);
  const [updatePolicy, { loading }] = useMutation(UPDATE_POLICY_SET, {
    client: RMMClient,
    onCompleted: (res) => {
      if (res) {
        toast('success', 'rmm.policy.override.revert.success');
      }
      setShowRevertConfirmation(false);
      tabContext.resetTabState();
      policyContext?.refreshAlertPolicyList();
      useActivityTracker({
        event: 'Policy - Overridden Revert'
      });
    },
    onError: () => {
      tabContext.resetTabState();
    }
  });

  const [deletePolicySet, { loading: deleteLoader }] = useMutation(
    DELETE_POLICY_SET_ASSET_ONBOARDING,
    {
      client: RMMClient,
      onCompleted: (res) => {
        if (res) {
          toast('success', 'rmm.policy.override.revert.success');
        }
        setShowRevertConfirmation(false);
        tabContext.resetTabState();
        policyContext?.refreshAlertPolicyList();
        useActivityTracker({
          event: 'Policy - Overridden Revert'
        });
      },
      onError: () => {
        tabContext.resetTabState();
      }
    }
  );

  const revertOverriddenPolicy = () => {
    const {
      clientId,
      siteId,
      assetId,
      policySetName,
      policySetDescription,
      policySetId,
      category
    } = policySet;
    if (isNewDelete) {
      deletePolicySet({
        variables: {
          policyId: policy?.policyId
        }
      });
      return;
    }
    updatePolicy({
      variables: {
        policySetId,
        category,
        clientId: clientId || null,
        siteId: siteId || null,
        assetId: assetId || null,
        input: {
          name: policySetName,
          description: policySetDescription,
          policyAssociations: [
            {
              policyType,
              deletePolicies: [
                {
                  policyId: policy?.policyId
                }
              ]
            }
          ]
        }
      }
    });
  };
  return (
    <div className="ml-16">
      <div className="flex g10">
        <Badge status="warning" size="large">
          <FormattedMessage id="admin.policyManagement.intelligentAlerting.overridden" />
        </Badge>
        {!isReadOnly && (
          <div
            className={`${
              fromListView ? 'policy-delete-block delete-btn' : ''
            }`}
          >
            <Button
              plain
              monochrome
              onClick={() => setShowRevertConfirmation(true)}
              icon={<SVGIcon name="Revert" size="sm" />}
            >
              <FormattedMessage id="common.revert" />
            </Button>
          </div>
        )}
      </div>
      <Modal
        variant="confirmation"
        open={showRevertConfirmation}
        title={
          <FormattedMessage id="policy.override.revert.confirmation.title" />
        }
        primaryAction={{
          content: (
            <div className="flex actr">
              <Button
                plain
                loading={loading || deleteLoader}
                icon={<SVGIcon name="CircleTickOutlineMinor" />}
                monochrome
              >
                <FormattedMessage id="common.yes" />
              </Button>
            </div>
          ),
          onAction: () => revertOverriddenPolicy()
        }}
        secondaryActions={[
          {
            content: <FormattedMessage id="common.no" />,
            onAction: () => setShowRevertConfirmation(false)
          }
        ]}
      >
        <div className="mt-10">
          <TextStyle>
            <FormattedMessage id="rmm.policy.override.revert.confirmation" />
          </TextStyle>
        </div>
      </Modal>
    </div>
  );
}
export default withErrorBoundary(OverRiddenPolicyTag);
